import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/farmtradedirect/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/components/HomepageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/components/MarketplaceListingsScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/components/MarketReportsSignup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/components/NewsUpdatesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/farmtradedirect/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/components/ui/AppLogo.tsx");
